import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";

export const generateArticleSchema = (article) => {
  let articleBodyText = "";
  if (article.body?.raw) {
    try {
      const content = JSON.parse(article.body.raw);
      articleBodyText = documentToPlainTextString(content);
    } catch (e) {
      console.warn("Could not parse rich text content for schema");
    }
  }

  const image = article.body?.references?.find(
    (ref) => ref.__typename === "ContentfulAsset" && ref.file?.contentType?.startsWith("image/")
  )?.file?.url;

  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: articleBodyText.trim(),
    ...(image && { image: [image] }),
  };
};
